import React, { useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'
import { Download } from 'lucide-react'
import { PageActionButton } from 'uiComponents/buttons/pageAddButton'
import OrdersSectionTabs from 'orders/sectionTabs'
import { TableToolbar } from 'uiComponents/table/tableToolbar'
import { BaseRouteParams } from 'hocs'
import DailyScheduleFilters from './components/dailyScheduleFilters'
import DailyScheduleTable from './table'
import { DateControls } from './components/dateControls'
import { useDateControl } from './hooks/useDateControl'
import { useOrdersData } from './hooks/useOrdersData'
import { useGetApfFieldsQuery } from 'orders/reduxQueries'
import { useTranslation } from 'translations'
import './styles.scss'

const DailySchedule: React.FC = () => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const printRef = useRef<HTMLDivElement>(null)
    const reactToPrintFn = useReactToPrint({ contentRef: printRef })
    const { selectedDate, handleDateChange, stepDate } = useDateControl()
    const { ordersCount } = useOrdersData(accountSlug, selectedDate)
    const { data: apfFields, isLoading: apfFieldsLoading } = useGetApfFieldsQuery({ accountSlug })

    return (
        <div id="orders__elem">
            <OrdersSectionTabs />
            <div className="daily-schedule-card">
                <DailyScheduleTable
                    selectedDate={selectedDate}
                    printRef={printRef}
                    apfFieldsKey={apfFields ?? { default: {}, custom: {} }}
                    toolbar={
                        <TableToolbar>
                            <div className="daily-schedule-toolbar">
                                <DateControls
                                    selectedDate={selectedDate}
                                    handleDateChange={handleDateChange}
                                    stepDate={stepDate}
                                    ordersCount={ordersCount}
                                />
                                <DailyScheduleFilters
                                    apfFields={apfFields ?? { default: {}, custom: {} }}
                                    apfFieldsLoading={apfFieldsLoading}
                                />
                                <PageActionButton
                                    icon={Download}
                                    className="daily-schedule-export"
                                    title={t('orders.dailySchedule.exportTitle')}
                                    onClick={() => reactToPrintFn()}
                                >
                                    {t('orders.dailySchedule.export')}
                                </PageActionButton>
                            </div>
                        </TableToolbar>
                    }
                />
            </div>
        </div>
    )
}

export default DailySchedule
